export const TOOL_USAGE_KEY = "seobix.freeToolUsage.v1";
export const FREE_TOOL_LIMIT = 5;
export const TOOL_LIMIT_EVENT = "seobix:tool-limit";
let fallbackCount = 0;
let queue = Promise.resolve();

export function getToolUsage() {
  try {
    const count = Number(window.localStorage.getItem(TOOL_USAGE_KEY) || 0);
    return Math.max(fallbackCount, Number.isFinite(count) ? Math.max(0, count) : FREE_TOOL_LIMIT);
  } catch {
    return fallbackCount;
  }
}

export function showToolLimit() {
  window.dispatchEvent(new Event(TOOL_LIMIT_EVENT));
}

function reserveUse() {
  const count = getToolUsage();
  if (count >= FREE_TOOL_LIMIT) {
    showToolLimit();
    return false;
  }
  fallbackCount = count + 1;
  try { window.localStorage.setItem(TOOL_USAGE_KEY, String(fallbackCount)); } catch { /* Keep enforcing for this page when storage is unavailable. */ }
  return true;
}

// Serialize reservations across tabs where Web Locks are supported.
export async function toolFetch(...args) {
  const reserve = () => reserveUse();
  const allowed = window.navigator.locks
    ? await window.navigator.locks.request("seobix-free-tool-usage", reserve)
    : await (queue = queue.then(reserve, reserve));
  if (!allowed) {
    // Existing tools expect JSON even for unsuccessful responses.
    return new Response(JSON.stringify({ status: "1", msg: "Free tool limit reached. Log in or choose a plan to continue.", data: [] }), {
      status: 429, headers: { "Content-Type": "application/json" },
    });
  }
  return window.fetch(...args);
}
